<template>
  <el-badge is-dot>
    <el-button size="mini" type="info" plain @click="dialog = true">Filtrar</el-button>
    <el-drawer title="Filtro de Ordem de Serviço" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
      ref="drawer" size="50%" :wrapperClosable="false" :append-to-body="true" :modal-append-to-body="false" :modal="true">
      <div class="demo-drawer__content" style="padding: 10px">
        <el-form :model="filter" label-position="top" size="mini">
          <el-row :gutter="5">
            <el-col :span="24">
              <el-form-item :label="$t('periodo')" prop="name">
                <el-date-picker v-model="filter.range" type="daterange" align="right" unlink-panels clearable
                  range-separator="à" format="dd/MM/yyyy" start-placeholder="Inicio"
                  end-placeholder="Fim"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="Objeto">
                <el-input v-model="filter.tag" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Status">
                <el-checkbox v-model="filter.open" label="1">Aberta</el-checkbox>
                <el-checkbox v-model="filter.print" label="2">Impressa</el-checkbox>
                <el-checkbox v-model="filter.close" label="3">Fechada</el-checkbox>
                <el-checkbox v-model="filter.collected" label="4">Coletada</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item :label="userType === '1' || userType === '3' ? $t('cliente') : $t('filial')" prop="name"
                v-if="userType !== '5'">
                <CustomerList v-model="filter.customer" v-bind:multiple="true"
                  v-bind:customerType="userType === '2' ? 3 : 0" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="close">Cancelar</el-button>
          <el-button type="info" @click="$refs.drawer.closeDrawer(); clear();">Limpar filtros</el-button>
          <el-button type="primary" @click="
            $refs.drawer.closeDrawer();
          execute();
          ">Filtrar</el-button>
        </div>
      </div>
    </el-drawer>
  </el-badge>
</template>

<script>
import CustomerList from "@/xpost/views/register/customer/CustomerList";
export default {
  props: ["userType"],
  components: {
    CustomerList,
  },
  data() {
    return {
      dialog: false,
      filter: {
        tag: "",
        customer: "",
        range: [new Date().setDate(new Date().getDate() - 30), new Date()],
        open: true,
        print: true,
        close: true,
        collected:true,
      },
    }
  },
  methods: {
    get() {
      return this.filter;
    },
    open() {
      const vm = this;
      vm.dialog = true;
    },
    close() {
      const vm = this;
      vm.dialog = false;
      vm.$refs.drawer.closeDrawer();
    },
    execute() {
      const vm = this;
      vm.$emit("filter");
      vm.dialog = false;
    },
    clear() {
      const vm = this;
      vm.filter.tag = "";
      vm.$emit('clearFilters')
      vm.filter.customer = "";
      vm.filter.close = true;
      vm.filter.open = true;
      vm.filter.print = true;
      vm.filter.collected = true
    },
  }
}
</script>